// /**
//  * skus -CSV
//  */

// React
import React from 'react';
import {CSVLink} from 'react-csv';
import {SkuInventory} from '../../warehouses/interfaces';
import Icon from '@mdi/react';
import {mdiTableArrowUp} from '@mdi/js';
import {Button} from '@material-ui/core';
import jMoment from 'moment-jalaali';

type Props = {
  data: SkuInventory[];
  handleCreateCSV: () => void;
  loading: boolean;
};

function CSV({data, handleCreateCSV, loading}: Props) {

  const flattData = (data: any) => {
    const newData = data.map(el => {
      let featureList = ''
      if(el.features) {
        for (let i = 0; i <= 2 && el.features[i]; i++) {
          featureList = featureList.concat(
            ' - ',
            el.features[i].key,
            ' : ',
            el.features[i].value
          );
        }
      }

      return {
        ...el,
        features: el.features ? featureList : undefined,
        date: el.date ? jMoment(el.date, 'YYYY/MM/DD').locale('fa').format('jYYYY/jMM/jDD') : undefined
      };
    })
    return newData
  };

  return (
    data?.length > 0 ? (
      <CSVLink
        data={flattData(data)}
        filename="skus.csv"
        style={{
          backgroundColor: '#DFA01F',
          padding: '10px',
          color: '#fff',
          marginLeft: '5px',
          textDecoration: 'none',
        }}
      >
        دانلود CSV
      </CSVLink>
    ) : (
      <Button
        style={{margin: '0 5px'}}
        variant="contained"
        color="primary"
        startIcon={<Icon path={mdiTableArrowUp} size={1} />}
        onClick={handleCreateCSV}
        disabled={loading}
      >
        ایجاد فایل CSV
      </Button>
    )
  );
}

export default CSV;
